import { render, staticRenderFns } from "./codeInput.vue?vue&type=template&id=4284b07f&scoped=true"
import script from "./codeInput.vue?vue&type=script&lang=js"
export * from "./codeInput.vue?vue&type=script&lang=js"
import style0 from "./codeInput.vue?vue&type=style&index=0&id=4284b07f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4284b07f",
  null
  
)

export default component.exports